import React, { useState, useEffect } from 'react';
import currencyService from '../../services/currency/currencyService';

const CurrencyRates = () => {
  const [rates, setRates] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRates = async () => {
      try {
        setLoading(true);
        setError(null);
        console.log('🔄 CurrencyRates: Fetching rates...');

        const currencyRates = await currencyService.getCurrencyRates();
        console.log('✅ CurrencyRates: Rates received:', currencyRates);

        setRates(currencyRates);
      } catch (err) {
        console.error('❌ CurrencyRates: Fetch error:', err);
        setError(err.message || 'Kur bilgileri alınamadı');
        setRates(null);
      } finally {
        setLoading(false);
      }
    };

    // İlk yükleme
    fetchRates();

    // Her 5 dakikada bir güncelle
    const interval = setInterval(fetchRates, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const refreshRates = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('🔄 CurrencyRates: Manual refresh...');

      currencyService.clearCache();
      const currencyRates = await currencyService.getCurrencyRates();
      console.log('✅ CurrencyRates: Manual refresh successful:', currencyRates);

      setRates(currencyRates);
    } catch (err) {
      console.error('❌ CurrencyRates: Manual refresh error:', err);
      setError(err.message || 'Güncelleme başarısız');
      setRates(null);
    } finally {
      setLoading(false);
    }
  };

  // Hover mesajını belirle
  const getHoverMessage = () => {
    if (loading) return 'Yükleniyor...';
    if (error) return `Hata: ${error}`;
    if (!rates) return 'Kur bilgileri alınamadı';

    const sourceMessage = `Kaynak: ${rates.sourceName || 'Bilinmiyor'}`;
    const rateInfo = `USD: ${currencyService.formatRate(rates.USD?.buying)} | EUR: ${currencyService.formatRate(rates.EUR?.buying)}`;

    return `${sourceMessage} • ${rateInfo} • Yenilemek için tıklayın`;
  };

  if (loading && !rates) {
    return (
      <div className="currency-rates-container">
        <div className="currency-rates-loading">
          <div className="animate-pulse flex space-x-2">
            <div className="h-4 w-12 bg-gray-300 rounded"></div>
            <div className="h-4 w-12 bg-gray-300 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  // Hata durumunda
  if (error && !rates) {
    return (
      <div className="currency-rates-container">
        <div
          className="currency-rates currency-rates-error"
          onClick={refreshRates}
          title={`Hata: ${error} • Tekrar denemek için tıklayın`}
        >
          {loading && (
            <div className="currency-loading-indicator">
              <div className="animate-spin h-3 w-3 border border-red-400 border-t-transparent rounded-full"></div>
            </div>
          )}

          <div className="currency-error-display">
            <span className="currency-error-icon">⚠️</span>
            <span className="currency-error-text">Kur Hatası</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="currency-rates-container">
      <div
        className="currency-rates"
        onClick={refreshRates}
        title={getHoverMessage()}
      >
        {loading && (
          <div className="currency-loading-indicator">
            <div className="animate-spin h-3 w-3 border border-gray-400 border-t-transparent rounded-full"></div>
          </div>
        )}

        <div className="currency-item">
          <span className="currency-symbol">💵</span>
          <span className="currency-code">USD</span>
          <span className="currency-rate">
            {rates ? currencyService.formatRate(rates.USD.buying) : '-.--'}
          </span>
        </div>

        <div className="currency-divider">|</div>

        <div className="currency-item">
          <span className="currency-symbol">💶</span>
          <span className="currency-code">EUR</span>
          <span className="currency-rate">
            {rates ? currencyService.formatRate(rates.EUR.buying) : '-.--'}
          </span>
        </div>
      </div>

      {rates?.lastUpdated && (
        <div className="currency-update-time">
          Son güncelleme: {new Date(rates.lastUpdated).toLocaleTimeString('tr-TR', {
            hour: '2-digit',
            minute: '2-digit'
          })}
          {rates?.sourceName && (
            <div className="currency-source-name">
              Kaynak: {rates.sourceName}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CurrencyRates;
